import React from "react";
import ZoomOutMapIcon from "@material-ui/icons/ZoomOutMap";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import OpacityIcon from "@material-ui/icons/Opacity";
import Crop169Icon from "@material-ui/icons/Crop169";
import Crop54Icon from "@material-ui/icons/Crop54";
import CropLandscapeIcon from "@material-ui/icons/CropLandscape";
import FormatAlignLeftIcon from "@material-ui/icons/FormatAlignLeft";
import FormatAlignCenterIcon from "@material-ui/icons/FormatAlignCenter";
import FormatAlignRightIcon from "@material-ui/icons/FormatAlignRight";
import SettingsOverscanOutlinedIcon from "@material-ui/icons/SettingsOverscanOutlined";
import ImageAspectRatioOutlinedIcon from "@material-ui/icons/ImageAspectRatioOutlined";
import VerticalAlignBottomIcon from "@material-ui/icons/VerticalAlignBottom";
import VerticalAlignCenterIcon from "@material-ui/icons/VerticalAlignCenter";
import VerticalAlignTopIcon from "@material-ui/icons/VerticalAlignTop";

const HorizontalAlignLeftIcon = () => <VerticalAlignBottomIcon style={{ transform: "rotate(-90deg)" }} />;
const HorizontalAlignCenterIcon = () => <VerticalAlignCenterIcon style={{ transform: "rotate(90deg)" }} />;
const HorizontalAlignRightIcon = () => <VerticalAlignTopIcon style={{ transform: "rotate(90deg)" }} />;

const onUnitChange = (u, v) => {
  let value = v;
  if (!value) return value;
  if (value.includes("%")) value = value.replace("%", u);
  else value = v.replace(/[^0-9\d.-]/g, "") + u;
  return value;
};

export const imageSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "url",
    label: "ImageUrl",
    type: "MULTI_INPUT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "linkEnabled",
    label: "ImageLinkEnabled",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "link",
    label: "ImageLink",
    type: "TEXT",
    showIf: { name: "linkEnabled", value: true },
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "ratio",
    label: "Ratio",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      {
        name: "LOCK",
        label: "Lock",
        icon: <ImageAspectRatioOutlinedIcon />,
      },
      {
        name: "AUTO",
        label: "Auto",
        icon: <SettingsOverscanOutlinedIcon />,
      },
    ],
  },
  /* {
    tab: "ContentSettings",
    name: "shape",
    label: "Shape",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      { name: "DEFAULT", label: "Default", icon: <AspectRatioOutlinedIcon /> },
      {
        name: "SQUARE",
        label: "Square",
        icon: <CheckBoxOutlineBlankOutlinedIcon />,
      },
      {
        name: "CIRCLE",
        label: "Circle",
        icon: <RadioButtonUncheckedOutlinedIcon />,
      },
    ],
  }, */
  {
    tab: "ContentSettings",
    name: "backgroundColor",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "opacity",
    label: "Opacity",
    type: "SLIDER",
    showIf: null,
    prop: "settings",
    extra: {
      defaultValue: 1,
      max: 1,
      min: 0,
      steps: 0.1,
    },
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*       { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];
export const clientListSettingsList = [
  {
    tab: "ContentSettings",
    name: "display",
    label: "Display",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      { name: "connected", label: "Connected", icon: <Crop169Icon /> },
      { name: "all", label: "All", icon: <CropLandscapeIcon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "booked",
    label: "Booked",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      { name: "off", label: "Off", icon: <Crop169Icon /> },
      { name: "current", label: "CurrentRoom", icon: <CropLandscapeIcon /> },
      { name: "breakout", label: "SelectedBreakout", icon: <CropLandscapeIcon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "bookedEventId",
    label: "BookedBreakout",
    showIf: { name: "booked", value: "breakout" },
    type: "EVENT_SELECT",
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showTitle",
    label: "ShowTitle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showSearchbar",
    label: "ShowSearchbar",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showAvatar",
    label: "ShowAvatar",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];
export const zoomSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "meetingId",
    label: "MeetingId",
    type: "text",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "password",
    label: "Password",
    type: "text",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "active",
    label: "StartMeeting",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "lockAspectRatio",
    label: "LockAspectRatio",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "aspectRatio",
    label: "AspectRatio",
    type: "BUTTON_GROUP",
    showIf: { name: "lockAspectRatio", value: true },
    prop: "settings",
    extra: [
      { name: "16:9", label: "16:9", icon: <Crop169Icon /> },
      { name: "16:10", label: "16:10", icon: <CropLandscapeIcon /> },
      { name: "4:3", label: "4:3", icon: <Crop54Icon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*       { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const jitsiSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "meetingName",
    label: "MeetingName",
    type: "text",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "lockAspectRatio",
    label: "LockAspectRatio",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "aspectRatio",
    label: "AspectRatio",
    type: "BUTTON_GROUP",
    showIf: { name: "lockAspectRatio", value: true },
    prop: "settings",
    extra: [
      { name: "16:9", label: "16:9", icon: <Crop169Icon /> },
      { name: "16:10", label: "16:10", icon: <CropLandscapeIcon /> },
      { name: "4:3", label: "4:3", icon: <Crop54Icon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*       { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const videoSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "url",
    label: "VideoUrl",
    type: "text",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "lockAspectRatio",
    label: "LockAspectRatio",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "aspectRatio",
    label: "AspectRatio",
    type: "BUTTON_GROUP",
    showIf: { name: "lockAspectRatio", value: true },
    prop: "settings",
    extra: [
      { name: "16:9", label: "16:9", icon: <Crop169Icon /> },
      { name: "16:10", label: "16:10", icon: <CropLandscapeIcon /> },
      { name: "4:3", label: "4:3", icon: <Crop54Icon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*       { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const buttonSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "url",
    label: "Url",
    type: "LINK_INPUT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayText",
    label: "ButtonText",
    type: "TEXT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "openInNewWindow",
    label: "OpenInNewWindow",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "useTemplateStyle",
    label: "OverwriteTemplateStyle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*       { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "backgroundColor",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "borderColor",
    label: "BorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "borderWidth",
    label: "BorderWidth",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "borderRadius",
    label: "BorderRadius",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 50,
      min: 1,
    },
  },

  //boxshadow
];

export const textSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "text",
    label: "Text",
    type: "TEXTAREA",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*       { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
  {
    tab: "StyleSettings",
    name: "textAlign",
    label: "TextAlignment",
    type: "BUTTON_GROUP_SMALL",
    showIf: null,
    prop: "settings",
    extra: [
      { name: "left", label: "Left", icon: <FormatAlignLeftIcon /> },
      /*       { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> }, */
      { name: "center", label: "Center", icon: <FormatAlignCenterIcon /> },
      { name: "right", label: "Right", icon: <FormatAlignRightIcon /> },
    ],
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontFamily",
    label: "FontFamily",
    type: "FONTFAMILY_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontWeight",
    label: "FontWeight",
    type: "FONTWEIGHT_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },

  //boxshadow
];

export const blockSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "StyleSettings",
    name: "background",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "borderColor",
    label: "BorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "borderWidth",
    label: "BorderWidth",
    type: "SLIDER",
    showIf: null,
    prop: "settings",
    extra: {
      defaultValue: 0,
      max: 20,
      min: 0,
      steps: 0.1,
    },
  },
  {
    tab: "StyleSettings",
    name: "borderRadius",
    label: "BorderRadius",
    type: "SLIDER",
    showIf: null,
    prop: "settings",
    extra: {
      defaultValue: 4,
      max: 50,
      min: 0,
      steps: 0.1,
    },
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*       { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
  //boxshadow
];

export const groupGeneratorSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "breakoutId",
    label: "BreakoutId",
    type: "EVENT_SELECT",
    showIf: null,
    prop: "settings",
  },
  /*  {
    tab: "ContentSettings",
    name: "breakoutId",
    label: "BreakoutId",
    type: "TEXT",
    showIf: null,
    prop: "settings",
  }, */
  {
    tab: "ContentSettings",
    name: "rooms",
    label: "NumberOfRooms",
    type: "NUMBER",
    showIf: null,
    prop: "settings",
    extra: {
      defaultValue: 3,
      max: 1000,
      min: 1,
      steps: 1,
    },
  },
  {
    tab: "ContentSettings",
    name: "max",
    label: "MaxCount",
    type: "number",
    showIf: null,
    prop: "settings",
    extra: {
      defaultValue: 3,
      max: 1000,
      min: 1,
      steps: 1,
    },
  },
  {
    tab: "ContentSettings",
    name: "text",
    label: "ButtonText",
    type: "text",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const breakoutSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "filterByGroup",
    label: "FilterEventsByGroup",
    type: "TEXT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showTitle",
    label: "ShowTitle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "collapsibleDescription",
    label: "CollapsibleDescription",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showSubtitle",
    label: "ShowSubtitle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showAvatar",
    label: "ShowAvatar",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showButton",
    label: "ShowButton",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "divideTimeslot",
    label: "DivideRowsByTime",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showAlternativeName",
    label: "ShowAlternativeName",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];
export const exhibitorSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },

  {
    tab: "ContentSettings",
    name: "filterByGroup",
    label: "FilterByGroup",
    type: "TEXT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "carousel",
    label: "Carousel",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "textLeft",
    label: "TextToLeft",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "scroll",
    label: "Scroll",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showText",
    label: "ShowTextInsteadOfImage",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "oneRow",
    label: "OneRow",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "colsPerRow",
    label: "ColsPerRow",
    type: "NUMBER",
    showIf: { name: "oneRow", value: false },
    prop: "settings",
    extra: {
      defaultValue: 3,
      max: 12,
      min: 1,
      steps: 1,
    },
  },
  {
    tab: "ContentSettings",
    name: "hideText",
    label: "HideText",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /* { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const userCardSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "allowProfileEdit",
    label: "AllowProfileEdit",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const imageSourceSettinglist = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "url",
    label: "ImageSource",
    type: "TEXT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "data",
    label: "JsonData",
    type: "TEXT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "target",
    label: "TargetTab",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "_blank", label: "NewTab", icon: <ArrowUpwardIcon /> },
      { name: "_self", label: "SameTab", icon: <ZoomOutMapIcon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const chatSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "hideMessages",
    label: "HideMessages",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showUserProfileImage",
    label: "ShowUserProfileImage",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showAllConnections",
    label: "ShowAllConnections",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "showSnackbar",
    label: "ShowMissedMessageSnackbar",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "hideFooter",
    label: "HideFooter",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "hideHeader",
    label: "HideHeader",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "getChatFromEvent",
    label: "GetChatFromEvent",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "requestedEventId",
    label: "requestedEventId",
    type: "EVENT_SELECT",
    showIf: { name: "getChatFromEvent", value: true },
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "vertical",
    label: "VerticalSnackbarPosition",
    type: "ANIMATION_GROUP",
    showIf: { name: "showSnackbar", value: true },
    prop: "settings",
    subProp: "snackbarPostion",
    extra: [
      { name: "top", label: "Top", icon: <VerticalAlignTopIcon /> },
      { name: "bottom", label: "Bottom", icon: <VerticalAlignBottomIcon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "horizontal",
    label: "HorizontalSnackbarPosition",
    type: "ANIMATION_GROUP",
    showIf: { name: "showSnackbar", value: true },
    prop: "settings",
    subProp: "snackbarPostion",
    extra: [
      { name: "left", label: "Left", icon: <HorizontalAlignLeftIcon /> },
      { name: "center", label: "Center", icon: <HorizontalAlignCenterIcon /> },
      { name: "right", label: "Right", icon: <HorizontalAlignRightIcon /> },
    ],
  },

  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const pollModuleSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];
export const presenterModule = [
  {
    tab: "ContentSettings",
    name: "showLabel",
    label: "ShowQuestionLabel",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },

  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];
export const vongageSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "StyleSettings",
    name: "backgroundColor",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "allowFullscreen",
    label: "AllowFullscreen",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "backstage",
    label: "UseBackstage",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },

  {
    tab: "ContentSettings",
    name: "requestedEventId",
    label: "GetStreamFromOtherRoom",
    type: "EVENT_SELECT",
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "aspectRatio",
    label: "AspectRatio",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      { name: "16:9", label: "16:9", icon: <Crop169Icon /> },
      { name: "16:10", label: "16:10", icon: <CropLandscapeIcon /> },
      { name: "4:3", label: "4:3", icon: <Crop54Icon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
  {
    tab: "ContentSettings",
    name: "showNametags",
    label: "ShowNametags",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      {
        name: "ALWAYS",
        label: "Always",
        icon: <ImageAspectRatioOutlinedIcon />,
      },
      {
        name: "NEVER",
        label: "Never",
        icon: <SettingsOverscanOutlinedIcon />,
      },
      {
        name: "HOVER",
        label: "Hover",
        icon: <SettingsOverscanOutlinedIcon />,
      },
    ],
  },
];

export const htmlSettingsList = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "html",
    label: "SourceCode",
    type: "SOURCE_EDITOR",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];
export const plauditButtonSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "expanded",
    label: "PlauditExpanded",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "columns",
    label: "Columns",
    type: "NUMBER",
    showIf: { name: "expanded", value: true },
    prop: "settings",
    extra: {
      defaultValue: 2,
      max: 20,
      min: 1,
      steps: 1,
    },
  },
  {
    tab: "ContentSettings",
    name: "icons",
    label: "Icons",
    type: "ICON_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
  {
    tab: "StyleSettings",
    name: "fabColor",
    label: "FabColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fabIconColor",
    label: "FabIconColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "buttonBackgroundColor",
    label: "ButtonBackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "buttonBorderColor",
    label: "ButtonBorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
];
export const plauditTrackSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
  {
    tab: "StyleSettings",
    name: "backgroundColor",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
];
export const agendaSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "hideTitle",
    label: "HideTitle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "hideSubtitle",
    label: "HideSubtitle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "hideSpeaker",
    label: "HideSpeakerCard",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "getAgendaFromOtherEvent",
    label: "GetAgendaFromOtherEvent",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "requestedEventId",
    label: "GetAgendaFrom",
    type: "EVENT_SELECT",
    showIf: { name: "getAgendaFromOtherEvent", value: true },
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "collapsibleAgenda",
    label: "CollapsibleAgenda",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "allowRequestTheFloor",
    label: "RequestTheFloor",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "allowPointOfOrder",
    label: "PointOfOrder",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "allowRequestLineOfSpeaker",
    label: "RequestLineOfSpeaker",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const speakerControlSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "allowRequestTheFloor",
    label: "RequestTheFloor",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "allowPointOfOrder",
    label: "PointOfOrder",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "allowRequestLineOfSpeaker",
    label: "RequestLineOfSpeaker",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "overwriteTemplateButtonStyle",
    label: "OverwriteTempalteButtonStyle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontFamily",
    label: "FontFamily",
    type: "FONTFAMILY_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontWeight",
    label: "FontWeight",
    type: "FONTWEIGHT_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "borderRadius",
    label: "BorderRadius",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "background",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "borderColor",
    label: "BorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "buttonBackground",
    label: "ButtonBackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const eventNameSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontFamily",
    label: "FontFamily",
    type: "FONTFAMILY_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontWeight",
    label: "FontWeight",
    type: "FONTWEIGHT_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },

  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const contentViewSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "menuOptions",
    label: "MenuOptions",
    type: "MENU_EDITOR",
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontFamily",
    label: "FontFamily",
    type: "FONTFAMILY_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontWeight",
    label: "FontWeight",
    type: "FONTWEIGHT_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "background",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
    separator: true,
  },
  {
    tab: "StyleSettings",
    name: "borderColor",
    label: "MenuBorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "borderWidth",
    label: "MenuBorderWidth",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },

  {
    tab: "ContentSettings",
    name: "justifyContent",
    label: "MenuOptionAlignment",
    type: "BUTTON_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      {
        name: "flex-start",
        label: "Left",
        icon: <FormatAlignLeftIcon />,
      },
      {
        name: "center",
        label: "Center",
        icon: <FormatAlignCenterIcon />,
      },
      {
        name: "flex-end",
        label: "Right",
        icon: <FormatAlignRightIcon />,
      },
    ],
  },
];

export const speakerCardSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontFamily",
    label: "FontFamily",
    type: "FONTFAMILY_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontWeight",
    label: "FontWeight",
    type: "FONTWEIGHT_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "background",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
    separator: true,
  },
  {
    tab: "StyleSettings",
    name: "imageSize",
    label: "ImageSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 70,
      units: ["px"],
      activeUnit: "px",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
    separator: true,
  },
  {
    tab: "StyleSettings",
    name: "imageBorderColor",
    label: "ImageBorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "imageBorderWidth",
    label: "ImageBorderWidth",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
    separator: true,
  },
  {
    tab: "StyleSettings",
    name: "containerBorderColor",
    label: "ContainerBorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "containerBorderWidth",
    label: "ContainerBorderWidth",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const speakerListSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontFamily",
    label: "FontFamily",
    type: "FONTFAMILY_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontWeight",
    label: "FontWeight",
    type: "FONTWEIGHT_SELECT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "background",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
    separator: true,
  },
  {
    tab: "StyleSettings",
    name: "imageBorderColor",
    label: "ImageBorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "imageBorderWidth",
    label: "ImageBorderWidth",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
    separator: true,
  },
  {
    tab: "StyleSettings",
    name: "containerBorderColor",
    label: "ContainerBorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "containerBorderWidth",
    label: "ContainerBorderWidth",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const videoWallSettingsList = [
  {
    tab: "ContentSettings",
    name: "wallName",
    label: "WallName",
    type: "TEXT",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "balanceScreens",
    label: "BalanceScreens",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },

  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
  {
    tab: "StyleSettings",
    name: "useTemplateStyle",
    label: "OverwriteTemplateStyle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "backgroundColor",
    label: "BackgroundColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "borderColor",
    label: "BorderColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "fontSize",
    label: "FontSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "borderWidth",
    label: "BorderWidth",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "borderRadius",
    label: "BorderRadius",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 50,
      min: 1,
    },
  },
];

export const genericSettings = [
  {
    tab: "ContentSettings",
    name: "showSubtitle",
    label: "ShowSubtitle",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const countdownSettings = [
  {
    tab: "ContentSettings",
    name: "lockPosAndSize",
    label: "LockPosAndSize",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "show",
    label: "Show",
    type: "SWITCH",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "displayName",
    label: "DisplayName",
    type: "TEXT",
    showIf: null,
    prop: "module",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "Color",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "ContentSettings",
    name: "datetime",
    label: "CountdownTime",
    type: "DATE_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "color",
    label: "TextColor",
    type: "COLOR_PICKER",
    showIf: null,
    prop: "settings",
  },
  {
    tab: "StyleSettings",
    name: "textSize",
    label: "TextSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "StyleSettings",
    name: "numberSize",
    label: "NumberSize",
    type: "SLIDER",
    prop: "settings",
    extra: {
      defaultValue: 18,
      units: ["vh", "px", "%"],
      activeUnit: "vh",
      onUnitChange: onUnitChange,
      steps: 1,
      max: 100,
      min: 1,
    },
  },
  {
    tab: "ContentSettings",
    name: "entranceAnimation",
    label: "EntranceAnimation",
    type: "ANIMATION_GROUP",
    showIf: null,
    prop: "settings",
    extra: [
      /*   { name: "GROW", label: "Grow", icon: <HeightIcon /> }, */
      { name: "SLIDE", label: "Slide", icon: <ArrowUpwardIcon /> },
      { name: "ZOOM", label: "Zoom", icon: <ZoomOutMapIcon /> },
      { name: "FADE", label: "Fade", icon: <OpacityIcon /> },
    ],
  },
];

export const defaultModuleSettings = (module) => {
  return {
    ...moduleSettings(module),
    entranceAnimation: "ZOOM",
    animationDuration: 2000,
    lockPosAndSize: false,
    show: true,
  };
};

const moduleSettings = (type) => {
  switch (type) {
    case "Image":
      return image;
    case "Breakouts":
      return breakout;
    case "Agenda":
      return agenda;
    case "ZoomFrame":
      return zoom;
    case "Iframe":
      return iframe;
    case "ClientFrame":
      return {};
    case "JitsiFrame":
      return jitsi;
    case "Video":
      return video;
    case "UserCard":
      return userCard;
    case "ButtonModule":
      return button;
    case "TextModule":
      return text;
    case "VonageVideoClientModule":
      return vonage;
    case "BlockModule":
      return block;
    case "Chat":
      return chat;
    case "Exhibitors":
      return exhibitor;
    case "Connections":
      return {};
    case "GroupGenerator":
      return groupGenerator;
    case "ClientList":
      return clientList;
    case "Poll":
      return poll;
    case "Html":
      return html;
    case "SpeakerControl":
      return speakerControl;
    case "Iframe":
      return {};
    case "ImageMap":
      return imageMap;
    case "CountdownModule":
      return countdown;
    case "VideoWallModule":
      return videoWall;
    case "SpeakerCard":
      return speakerCard;
    case "SpeakerList":
      return speakerList;
    case "EventName":
      return eventName;
    case "ContentView":
      return contentView;
    case "Presenter":
      return presenter;
    default:
      return {};
  }
};

const countdown = {
  color: "#000",
  datetime: null,
  textSize: 15,
  numberSize: 15,
};
const clientList = {
  display: "connected",
  booked: "off",
  showTitle: true,
  showSearchbar: true,
  showAvatar: true,
};
const exhibitor = {
  display: "GRID" /*GRID/LIST */,
  wrapper: "NONE" /*Bottomdialog/Dialog/GROW */,
  carousel: false,
  showSlideNo: false,
  oneRow: false,
  collapsible: false,
  icon: null,
  colsPerRow: 3,
  hideText: false,
  textLeft: false,
  scroll: false,
  showText: false,
  /*   colMaxHeight: "auto", */
  filterByGroup: "",
};

const speakerList = {
  backgroundColor: "#fff",
  fontFamily: "Open Sans",
  color: "#222",
  fontWeight: "normal",
};

const breakout = {
  display: "GRID" /*GRID/LIST */,
  wrapper: "NONE" /*Bottomdialog/Dialog/GROW */,
  collapsible: false,
  icon: null,
  showTitle: true,
  showSubtitle: true,
  collapsibleDescription: true,
  showAvatar: true,
  showButtonIcon: true,
  divideTimeslot: false,
  filterByGroup: "",
  showAlternativeName: false,
};

const poll = {
  collapsible: false,
};
const presenter = {
  showLabel: true,
};
const block = {
  background: "#fff",
  borderRadius: "4px",
  borderWidth: "0px",
  borderColor: "#fff",
  borderStyle: "solid",
  boxShadow: "none",
};

const speakerCard = {
  fontFamily: "inherit",
  fontSize: "2.2vh",
  color: "#ff",
  fontWeight: "normal",
  background: "#fff",

  imageBorderWidth: "8px",
  imageBorderColor: "#fff",
  imageSize: "100px",
  containerBorderWidth: "0px",
  containerBorderColor: "transparent",
};

const contentView = {
  menuOptions: [],
  justifyContent: "center",
  fontFamily: "inherit",
  fontSize: "2.2vh",
  color: "#fff",
  fontWeight: "normal",
  background: "#fff",
  borderColor: "transparent",
  borderWidth: 0,
};

const speakerControl = {
  allowRequestTheFloor: false,
  allowPointOfOrder: false,
  allowRequestLineOfSpeaker: false,
  overwriteTemplateButtonStyle: false,
  fontFamily: "inherit",
  fontSize: "2.2vh",
  color: "#fff",
  buttonBackground: "red",
  fontWeight: "normal",
  background: "#fff",
  borderColor: "transparent",
};

const agenda = {
  hideSpeaker: false,
  hideSubtitle: false,
  hideTitle: false,
  requestedEventId: null,
  getAgendaFromOtherEvent: false,
  allowRequestTheFloor: false,
  allowPointOfOrder: false,
  allowRequestLineOfSpeaker: false,
};

const eventName = {
  fontFamily: "inherit",
  fontSize: "2.2vh",
  color: "#ff",
  letterSpacing: "1px",
  textTransform: "none",
  fontWeight: "normal",
  lineHeight: "normal",
};

const text = {
  fontFamily: "inherit",
  fontSize: "2.2vh",
  color: "#ff",
  letterSpacing: "1px",
  textTransform: "none",
  fontWeight: "normal",
  lineHeight: "normal",
  text: "text",
};

const groupGenerator = {
  breakoutId: "",
  rooms: 10,
  max: 6,
  text: "ButtonText",
};

const chat = {
  showUserProfileImage: false,
  collapsible: false,
  showAllConnections: false,
  showSnackbar: false,
  hideFooter: false,
  hideHeader: false,
  requestedEventId: null,
  vertical: "top",
  horizontal: "left",
};

const userCard = {
  allowProfileEdit: false,
};

const button = {
  url: "https://google.se",
  buttonText: "Text",
  openInNewWindow: false,
  useTemplateStyle: false,
  backgroundColor: "unset",
  borderRadius: "unset",
  color: "unset",
  padding: "6px 12px 6px 12px",
  borderColor: "unset",
  fontSize: "unset",
  borderWidth: "unset",
  borderStyle: "unset",
};

const image = {
  url: "",
  backgroundColor: "none",
  opacity: 1,
  ratio: "AUTO",
  linkEnabled: false,
  link: "",
  shape: "DEFAULT" /* SQUARE / CIRCLE */,
};

const html = {
  html: "",
  css: "",
};

const iframe = {
  url: "",
  aspectRatio: "16:9",
  lockAspectRatio: false,
};

const imageMap = {
  url: "",
  data: "",
  target: "",
};

const vonage = {
  backgroundColor: "transparent",
  backstage: false,
  requestedEventId: null,
  allowFullscreen: true,
  showNametags: "NEVER",
  lockAspectRatio: true,
  aspectRatio: "16:9",
};

const video = {
  url: "",
  aspectRatio: "16:9",
  lockAspectRatio: false,
};
const jitsi = {
  meetingName: "",
  aspectRatio: "16:9",
  lockAspectRatio: false,
};
const zoom = {
  meetingId: "",
  password: "",
  aspectRatio: "16:9",
  lockAspectRatio: false,
  active: false,
};

const videoWall = {
  id: "",
  balanceScreens: false,
  useTemplateStyle: false,
  backgroundColor: "unset",
  borderRadius: "unset",
  color: "unset",
  padding: "6px 12px 6px 12px",
  borderColor: "unset",
  fontSize: "unset",
  borderWidth: "unset",
  borderStyle: "unset",
};

//HTML / BILD / EXHIBITOR/ STREAM /ZOOM /JITSI / AGENDA
